import ToastService from "./Toast.Service";

class QuotationServices {

    async createNewQuotation (jwtToken, reference, showToast) {
        const promise = fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/invoices/create",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({reference: reference}),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }

                return data;
            });

        if (showToast) {
            ToastService.promiseToast(promise, 'Nieuwe offerte aanmaken...', 'Offerte aangemaakt');
        }

       return promise;
    }
    async addLineToQuotation (jwtToken, quotationId, quantity, variantId, note, longitude, location, latitude, selectedImage, replaceLine, showToast = true){

        const data = {
            quantity: quantity,
            variant_id: variantId,
            note: note || "",
            longitude: longitude || "",
            location: location || "",
            latitude: latitude || "",
            image_id: selectedImage || null,
            replace_line: replaceLine ? replaceLine : null,
        };

        const promise = fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices/" +
            quotationId +
            "/add-line",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
            })
            .catch((error) => {
                throw error;
            });

        if (showToast) {
            ToastService.promiseToast(promise, 'Partij wordt toegevoegd...', 'Partij is toegevoegd aan de offerte');
        }

        return promise;
    }

    removeLineFromQuotation = (uid, jwtToken, showToast) => {
        const promise = fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices/" +
            uid +
            "/remove-line",
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        )
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }
            });

        if (showToast) {
            ToastService.promiseToast(promise);
        }

        return promise;
    };
}
export default new QuotationServices();